import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon
} from "@chakra-ui/react";
import { FaHandHolding, FaList, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";
import { tablesProjectData, tablesTableData } from "variables/general";
import useGetTools from "../../hooks/useGetTools";
import CreateTool from "../../modals/CreateTool";
import EditTool from "../../modals/EditTool";
import Pagination from "../Custom/Pagination";
import CreateLend from "../../modals/CreateLend";
import { MySearchBar }  from "../Custom/MySearchBar";
import LendsTable from "views/Custom/LendsTable";
import LendHistory from "../../modals/LendHistory";
import { useAuth } from "contexts/auth";

function Tools() {
  const [ keyword, setKeyword ] = useState("");
  const [ page, setPage ] = useState(1); 
  const pageLimit = 10;
  let { 
    tools, 
    totalTools, 
    setGettingTools, 
    gettingTools, 
    gettingToolsReqSuccess 
  } = useGetTools({ 
    page, 
    limit: pageLimit,
    keyword: keyword 
  });

  const authUser = useAuth();
  const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
  const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const { isOpen: isOpenCreateLend, onOpen: onOpenCreateLend, onClose: onCloseCreateLend } = useDisclosure();
  const { isOpen: isOpenHistoryLend, onOpen: onOpenHistoryLend, onClose: onCloseHistoryLend } = useDisclosure();
  const [ toEditTool, setToEditTool ] = useState(null);

  useEffect(() => {
    reloadPage();
  }, [page, keyword]);

  const reloadPage = () => {
    setGettingTools(true);
  }

  const selectEditItem = (id) => {
    // console.log(id);
    const tool = tools.find((c) => c.id === id);
    // console.log(tool.email);
    setToEditTool(tool);
    onOpenEdit(true);
  }


  const selectLendItem = (id) => {
    // console.log(id);
    const tool = tools.find((c) => c.id === id);
    // console.log(tool.email);
    setToEditTool(tool);
    onOpenCreateLend(true);
  }


  const selectHistoryItem = (id) => {
    // console.log(id);
    const tool = tools.find((c) => c.id === id);
    // console.log(tool);
    setToEditTool(tool);
    onOpenHistoryLend(true);
  }

  const textColor = useColorModeValue("gray.700", "white");


  return (
    <>
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px">
          <Flex w="100%"
            flexDirection={{
              sm: "row",
              md: "row",
            }}
            alignItems={{ xl: "center" }}>
            <Box marginRight={4}>
                <Text fontSize="lg" color={textColor} fontWeight="bold" pb=".5rem">
                Tools
                </Text>
            </Box>
            <MySearchBar 
                keyword={keyword}
                setKeyword={setKeyword}
                onReload={reloadPage}
              />
            <Spacer />
            <Box>
              {authUser.auth.role != 'auditor'
              ?<Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                Create New
              </Button>
              : null}
            </Box>
          </Flex>
          {/* <Text fontSize="xl" color={textColor} fontWeight="bold">
            Tools
          </Text> */}
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" color="gray.400">
                  <Th p={2} color="gray.400">Icon - Name</Th>
                  <Th p={2} color="gray.400">Description</Th>
                  <Th p={2} color="gray.400">Available/Quantity</Th>
                  <Th p={2} color="gray.400">Actions</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {gettingTools ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : tools.map((tool) => {
                    return (
                      <Tr my=".8rem" key={`tool-item-${tool.id}`}>
                        <Td p={2}>
                          <Flex direction="row" w="100%" align="center">
                            <img src={`data:image/jpeg;base64,${tool.cover}`} 
                              width="45" 
                              height="45"
                              margin="4px"
                            ></img>
                            <Text margin="4px"> </Text>
                            <Text margin="4px">{tool.name}</Text>
                          </Flex>
                        </Td>
                        <Td  p={2}>
                          {tool.description}
                        </Td>
                        <Td  p={2}>
                          {tool.available}/{tool.quantity}
                        </Td>
                        <Td  p={2}>
                          <Flex direction={"row"}>
                          {authUser.auth.role != 'auditor'
                          ?
                            <Button p="0px" bg="transparent" onClick={() => selectEditItem(tool.id)}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaPencilAlt} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  EDIT
                                </Text>
                              </Flex>
                            </Button>
                            : null }

                          {authUser.auth.role != 'auditor'
                          ?
                            <Button p="0px" bg="transparent" onClick={() => selectLendItem(tool.id)}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaHandHolding} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  LEND
                                </Text>
                              </Flex>
                            </Button>
                          : null }

                            <Button p="0px" bg="transparent" onClick={() => selectHistoryItem(tool.id)}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                  <Icon as={FaList} me="4px" />
                                  <Text fontSize="xs" fontWeight="semibold">VIEW HISTORY</Text>
                              </Flex>
                            </Button>

                          </Flex>
                          
                        </Td>
                      </Tr>
                    );
                  })
                }
              </Tbody>
            </Table>
            <Pagination 
              totalItems={totalTools}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
          </Flex>
        </CardBody>
      </Card>

      {/* <LendsTable /> */}
    </Flex>
    
   <CreateTool 
      isOpen={isOpenCreate}
      onClose={onCloseCreate}
      successCallback={reloadPage}
    />

               
    <EditTool 
      isOpen={isOpenEdit}
      onClose={() => {
        setToEditTool(null);
        onCloseEdit();
      }}
      successCallback={reloadPage}
      toolData={toEditTool}
    />

    <CreateLend 
      isOpen={isOpenCreateLend}
      onClose={() => {
        setToEditTool(null);
        onCloseCreateLend();
      }}
      successCallback={reloadPage}
      toolData={toEditTool}
    />

    <LendHistory 
      isOpen={isOpenHistoryLend}
      onClose={() => {
        setToEditTool(null);
        onCloseHistoryLend();
      }}
      successCallback={reloadPage}
      toolId={toEditTool ? toEditTool.id : null}
    />

    </>
  );
}

export default Tools;
